import React, { createContext, useContext, useState, useEffect } from 'react';
import { socket } from "../socket/socket";

const SessionContext = createContext();

export const SessionProvider = ({ children }) => {
  const [showTimeoutModal, setShowTimeoutModal] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(null);

  const handleLogout = () => {
    localStorage.clear();
    window.location.href = "/";
    setIsAuthenticated(false)
    // remove all listeners
    socket.removeAllListeners();
    // disconnect socket
    socket.disconnect();

    socket.auth = {};
  };

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token === null) {
        localStorage.clear();
        setIsAuthenticated(false);
        return;
    }
    else {
      setIsAuthenticated(true);
    }
}, []);

  return (
    <SessionContext.Provider value={{ showTimeoutModal, setShowTimeoutModal, handleLogout, isAuthenticated, setIsAuthenticated }}>
      {children}
    </SessionContext.Provider>
  );
};

export const useSession = () => useContext(SessionContext);
